import React from 'react';
import PropTypes from 'prop-types';
import * as S from './style';

const FormContainer = ({ children, style }) => (
  <S.FormContainer style={style}>{children}</S.FormContainer>
);

FormContainer.propTypes = {
  children: PropTypes.element.isRequired,
  style: PropTypes.object,
};

export default FormContainer;
